import React from 'react';

import Typography from 'components/typography/typography';

interface SideBarHeaderProps {
  label: string;
}

const SideBarHeader: React.FC<SideBarHeaderProps> = ({ label }) => {
  return (
    <Typography
      as="li"
      variant="body-medium"
      className="uppercase text-gray400 font-normal pl-3"
    >
      {label}
    </Typography>
  );
};

export default SideBarHeader;
